module.exports = __webpack_public_path__ + "img/motor_no62.370ab3de.jpg";